import { createFileRoute } from "@tanstack/react-router";
import { getIntegrationMetricConfigs, getMetricsAvailable } from "api-client";

import { AdminIntegrationConfigsPage } from "src/pages/AdminIntegrationConfigsPage";

export const Route = createFileRoute(
  "/_auth/_admin/admin/metrics/integration-configs",
)({
  component: RouteComponent,
  ssr: true,
  shouldReload: false,
  async loader() {
    const [configsRes, metricsRes] = await Promise.all([
      getIntegrationMetricConfigs(),
      getMetricsAvailable(),
    ]);
    const configData = configsRes.data.data as
      | {
          configs: Array<{
            id: string;
            integrationSource: string;
            sourceMetricName: string;
            metricId: string;
            metricName: string;
            metricUnit: string | null;
            isDailyAggregate: boolean;
          }>;
        }
      | undefined;
    return {
      data: {
        configs: configData?.configs || [],
        metrics: metricsRes.data.data || [],
      },
    };
  },
  staticData: {
    getBreadcrumb({ i18n }) {
      return {
        label: i18n.t("sidebar.integrationConfigs"),
        href: "/admin/metrics/integration-configs",
      };
    },
  },
});

function RouteComponent() {
  return <AdminIntegrationConfigsPage />;
}
